import { HTMLProps } from "react";
import classNames from "classnames";

import styles from "./formRow.module.css";

export const FormRow = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div className={classNames(styles.lgChildOneHalf, className)} {...props} />
);
